import { render, staticRenderFns } from "./EnquiryFollowUpsList.vue?vue&type=template&id=ca9cc4ce&scoped=true&"
import script from "./EnquiryFollowUpsList.vue?vue&type=script&lang=js&"
export * from "./EnquiryFollowUpsList.vue?vue&type=script&lang=js&"
import style0 from "./EnquiryFollowUpsList.vue?vue&type=style&index=0&id=ca9cc4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9cc4ce",
  null
  
)

export default component.exports